<!-- HEADER -->
<header id="main-header" class="py-2 bg-warning text-white">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <h1>
            <i class="fa fa-graduation-cap" aria-hidden="true"></i> Tutors
          </h1>
        </div>
      </div>
    </div>
  </header>
  
  <!-- SEARCH -->
  <section id="search" class="py-4 mb-4 bg-light">
    <div class="container">
      <div class="row">
        <div class="col-md-6 ml-auto">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Search Tutors...">
            <div class="input-group-append">
              <button class="btn btn-warning text-white">Search</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  <!-- SESSIONS -->
  <section id="sessions">
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="card">
            <div class="card-header text-center">
              <h4>All Tutors</h4>
            </div>
            <table class="table table-striped text-center">
              <thead class="thead-dark">
                <tr>
                  <!-- <th>#</th> -->
                  <th>Name</th>
                  <th>Tutor ID</th>
                  <th>Location</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let tutor of tutorList">
                  <!-- <td></td> -->
                  <td>{{ tutor.name }}</td>
                  <td>{{ tutor.code }}</td>
                  <td>{{ tutor.location }}</td>
                  <td>
                    <a class="btn btn-warning text-white" (click)="onTutorDetails(tutor._id)" data-toggle="modal" data-target="#tutorDetailsModal">
                      <i class="fas fa-angle-double-right"></i> Details
                    </a>
                  </td>
                </tr>
  
              </tbody>
            </table>
  
            <!-- PAGINATION -->
            <!-- <nav class="ml-4">
              <ul class="pagination">
                <li class="page-item disabled">
                  <a href="#" class="page-link">Previous</a>
                </li>
                <li class="page-item active">
                  <a href="#" class="page-link">1</a>
                </li>
                <li class="page-item">
                  <a href="#" class="page-link">2</a>
                </li>
                <li class="page-item">
                  <a href="#" class="page-link">3</a>
                </li>
                <li class="page-item">
                  <a href="#" class="page-link">Next</a>
                </li>
              </ul>
            </nav> -->
          </div>
        </div>
      </div>
    </div>
  </section>
  
  
  <!-- Tutor Details Modal -->
  <div class="modal fade" id="tutorDetailsModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header bg-warning text-white">
          <h5 class="modal-title" id="exampleModalLongTitle">{{ selectedTutor.name }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-5" style="text-align: right;">
              <b>TutorId :</b>
            </div>
            <div class="col-7">
              {{ selectedTutor.code }}
            </div>
          </div>
          <div class="row">
            <div class="col-5" style="text-align: right;">
              <b>Email :</b>
            </div>
            <div class="col-7">
              {{ selectedTutor.email }}
            </div>
          </div>
          <div class="row">
            <div class="col-5" style="text-align: right;">
              <b>Qualification :</b>
            </div>
            <div class="col-7">
              {{ selectedTutor.qualification }}
            </div>
          </div>
          <div class="row">
            <div class="col-5" style="text-align: right;">
              <b>Contact :</b>
            </div>
            <div class="col-7">
              {{ selectedTutor.mobileNumber }}
            </div>
          </div>
          <div class="row">
            <div class="col-5" style="text-align: right;">
              <b>Location :</b>
            </div>
            <div class="col-7">
              {{ selectedTutor.location }}
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-danger" data-dismiss="modal" (click)="onDeleteTutor(selectedTutor._id)">Remove {{ selectedTutor.name }}</button>
        </div>
      </div>
    </div>
  </div>
  